import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

function HeroSection() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        textAlign: "center",
        py: { xs: 6, md: 10 },
        px: 2,
        background: "linear-gradient(to bottom, #FFF7F0, #ffffff)",
      }}
    >
      <Typography
        variant="h3"
        sx={{ fontWeight: 800, mb: 2 }}
      >
        Create Marriage Biodata in 2 Minutes
      </Typography>

      <Typography sx={{ mb: 3, color: "#555" }}>
        Free • Professional • Instant PDF • No Login Required
      </Typography>

      <Button
        variant="contained"
        onClick={() => navigate("/create-biodata")}
        sx={{
          px: 4,
          py: 1.5,
          fontWeight: 700,
          borderRadius: 2,
          backgroundColor: "#e65100",
        }}
      >
        Create Free Biodata
      </Button>

      <Typography sx={{ mt: 2, fontSize: "0.9rem", color: "#777" }}>
        Trusted by 10,000+ users
      </Typography>
    </Box>
  );
}

export default HeroSection;